<div class="qa-section">
  <div class="section-header">
    <div class="section-icon">❓</div>
    <h2>{{ 'HOME.QA.SECTION_TITLE' | translate }} <span class="highlight-text">{{ 'HOME.QA.SECTION_TITLE_HIGHLIGHT' | translate }}</span></h2>
    <p class="section-subtitle">{{ 'HOME.QA.SECTION_SUBTITLE' | translate }}</p>
  </div>

  <div class="qa-container">
    @for (item of qaItems; track trackByFn($index, item)) {
      <div class="qa-item" [class.expanded]="item.isExpanded">
        <div class="qa-question" (click)="toggleExpanded(item)">
          <h3>{{ item.question | translate }}</h3>
          <div class="qa-toggle-icon" [class.rotated]="item.isExpanded">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>
        <div class="qa-answer" [class.show]="item.isExpanded">
          <div class="qa-answer-content">
            <p>{{ item.answer | translate }}</p>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- <div class="qa-footer">
  <div class="qa-contact">
    <h4>Still have questions?</h4>
    <p>Can't find the answer you're looking for? Please chat to our friendly team.</p>
    <button class="contact-btn">
      <span>Get in touch</span>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div> -->
</div>